












































import Vue from 'vue'
export default Vue.extend({
    data: () => ({
        loading: false
    }),
    computed: {
        isApp(): boolean {
            return this.$store.getters.isApp
        }
    },
    methods: {
        popBroadcastPractices(): void {
            //  Open via intercom
            window.Intercom('showArticle', 2565290)
        },
        popMoreConvos(): void {
            //  Open via intercom
            window.Intercom('showArticle', 8021211)
        },
        popTeamInbox(): void {
            //  Open via intercom
            window.Intercom('showArticle', 2565287)
        }
    }
})
